import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Hero from '../../components/pages/Home/Hero/Hero'
import OurSolution from '../../components/pages/Home/OurSolution/OurSolution'


import './Home.css'
import AboutUs from '../../components/pages/Home/AboutUs/AboutUs'
import Products from '../../components/pages/Home/Products/Products'
import OtherProducts from '../../components/pages/Home/OtherProducts/OtherProducts'
import Hospitality from '../../components/pages/Home/Hospitality/Hospitality'
import SuccessStory from '../../components/pages/Home/SuccessStory/SuccessStory'
import BecomePartner from '../../components/pages/Home/BecomePartner/BecomePartner'
import Academy from '../../components/pages/Home/Academy/Academy'
import BlogPosts from '../../components/pages/Home/BlogPosts/BlogPosts'
import CompanyProfile from '../../components/pages/Home/CompanyProfile/CompanyProfile'
import Footer from '../../components/shared/Footer/Footer'
import { useTranslation } from 'react-i18next'
import { usePageContent } from '../../hooks/usePublicQueries'

const unwrapSectionData = (section) => {
  if (section == null) return section
  if (typeof section === "string") {
    const t = section.trim()
    if (t.startsWith("{")) {
      try {
        const parsed = JSON.parse(t)
        if (parsed && typeof parsed === "object") return unwrapSectionData(parsed)
      } catch {
        return section
      }
    }
    return section
  }
  if (typeof section !== "object") return section
  if (section.data && typeof section.data === "object") return section.data
  return section
}

/** API keys may be PascalCase, camelCase, or snake_case — match by normalized slug. */
const normalizeSectionSlug = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[_\s-]+/g, "")

const findHomeSection = (root, slug) => {
  if (!root || typeof root !== "object") return undefined
  const target = normalizeSectionSlug(slug)
  const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target)
  return hit != null ? root[hit] : undefined
}

const Home = () => {
  const { i18n } = useTranslation()
  const { data: homeContent } = usePageContent("home", i18n.language)

  return (
    <div className='home'>
      <Navbar />
      <Hero content={unwrapSectionData(findHomeSection(homeContent, "hero"))} />
      <div className="home-content-guide">
        <OurSolution content={unwrapSectionData(findHomeSection(homeContent, "oursolution"))} />
        <AboutUs content={unwrapSectionData(findHomeSection(homeContent, "aboutus"))} />
        <Products
          content={unwrapSectionData(
            findHomeSection(homeContent, "allproducts") || findHomeSection(homeContent, "products")
          )}
        />
        <OtherProducts content={unwrapSectionData(findHomeSection(homeContent, "otherproducts"))} />
        <Hospitality content={unwrapSectionData(findHomeSection(homeContent, "hospitality"))} />
        <SuccessStory content={findHomeSection(homeContent, "successstory")} />
        <BecomePartner content={findHomeSection(homeContent, "becomepartner")} />
        <Academy content={findHomeSection(homeContent, "academy")} />
        <BlogPosts />
        <CompanyProfile content={findHomeSection(homeContent, "companyprofile")} />
      </div>
      <Footer />


    </div>
  )
}

export default Home